export default __webpack_public_path__ + "static/media/warning--winding-road-to-left--g1.896aa6f8.png";